import { IAM_TENANT_ID } from './msalConfig'

/**
 * Generate a minimal unsigned JWT (alg:none) for dev-mode API authentication.
 *
 * The ChecApi `ChecAuthenticationHandler` parses JWTs with `ReadJwtToken()` —
 * no signature validation. It checks the `tid` claim to route internal vs
 * external auth and `preferred_username` to resolve the username against the DB.
 *
 * The tenant ID comes from `REACT_APP_IAM_TENANT_ID` (.env.local) when set,
 * otherwise falls back to {@link IAM_TENANT_ID} from `auth/msalConfig`.
 *
 * **Node.js (setupProxy.js):** This module uses `btoa()` and ES module syntax,
 * so it cannot be imported from `setupProxy.js` which runs in the webpack-dev-server
 * Node.js process as CommonJS. `setupProxy.js` contains its own copy of this
 * function using `Buffer.from().toString('base64')` instead of `btoa()`.
 * Both copies must stay in sync — see the cross-reference comment there.
 *
 * @param {string} username - NTLM-style username (e.g. "KOERBEF").
 * @returns {string} Unsigned JWT: base64url(header).base64url(payload). (trailing dot, no signature)
 */
export function generateDevJwt(username) {
  const now = Math.floor(Date.now() / 1000)
  const tenantId = process.env.REACT_APP_IAM_TENANT_ID || IAM_TENANT_ID
  const header = { alg: 'none', typ: 'JWT' }
  const payload = {
    tid: tenantId,
    preferred_username: `${username}@corpintra.net`,
    iat: now,
    exp: now + 3600,
  }
  const b64url = (obj) =>
    btoa(JSON.stringify(obj))
      .replace(/\+/g, '-')
      .replace(/\//g, '_')
      .replace(/=+$/, '')
  return `${b64url(header)}.${b64url(payload)}.`
}
